import { createRouter, createWebHashHistory } from "vue-router";

import CreateLead from '../pages/CreateLead.vue';
import CreateCustomer from '../pages/CreateCustomer.vue';
import CreateDeliveryPerson from '../pages/CreateDeliveryPerson.vue';
import CreateFeedback from '../pages/CreateFeedback.vue';
import CreateGroup from '../pages/CreateGroup.vue';
import CreateNotification from '../pages/CreateNotification.vue';
import CreateSubscription from '../pages/CreateSubscription.vue';
import CreateTransaction from '../pages/CreateTransaction.vue';
import CreateVacation from '../pages/CreateVacation.vue';
import CustomerMapLocation from '../pages/CustomerMapLocation.vue';
import Customers from '../pages/Customers.vue';
import CustomersSort from '../pages/CustomersSort.vue';
import CustomersPotentialDropout from '../pages/CustomersPotentialDropout.vue';
import CustomersLowBalance from '../pages/CustomersLowBalance.vue';
import Dashboard from '../pages/Dashboard.vue';
import Deliveries from '../pages/Deliveries.vue';
import DeliveryPersons from '../pages/DeliveryPersons.vue';
import DeliveryPersonsTransaction from '../pages/DeliveryPersonsTransaction.vue'
import Groups from '../pages/Groups.vue';
import Leads from '../pages/Leads.vue';
import Login from '../pages/Login.vue';
import NotFound from '../pages/NotFound.vue';
import Notifications from '../pages/Notifications.vue';
import DeliveryIntents from '../pages/DeliveryIntents.vue';
import Orders from '../pages/Orders.vue';
import PastOrders from '../pages/PastOrders.vue';
import Profile from '../pages/Profile.vue';
import ProfileMap from '../pages/ProfileMap.vue';
import ReportDeliveryPersonsAttendanceSummary from "../pages/reports/DeliveryPersonsAttendanceSummary.vue";
import ReportDeliveryPersonsTransactionSummary from '../pages/reports/DeliveryPersonsTransactionSummary.vue';
import ReportCommission from '../pages/reports/Commission.vue';
import ReportCustomerSummary from '../pages/reports/CustomerSummary.vue';
import ReportDealerTnxSummary from '../pages/reports/DealerTnxSummary.vue';
import ReportDealerSampleSlot from '../pages/reports/SampleSlot.vue';
import ReportEmptyBottleSummary from '../pages/reports/EmptyBottleSummary.vue';
import ReportPendingBottleReturnSummary from '../pages/reports/PendingBottleReturnSummary.vue';
import ReportPendingBottleReturnAllSummary from '../pages/reports/PendingBottleReturnAllSummary.vue';
import ReportCrateSummary from '../pages/reports/CrateSummary.vue';
import ReportLowBalance from '../pages/reports/LowBalance.vue';
import Reports from '../pages/Reports.vue';
import ReportTransactions from '../pages/reports/Transactions.vue';
import Subscriptions from '../pages/Subscriptions.vue';
import SwitchProfile from '../pages/SwitchProfile.vue';
import Transactions from '../pages/Transactions.vue';
import Vacations from '../pages/Vacations.vue';
import ViewCustomer from '../pages/ViewCustomer.vue';
import ViewLead from '../pages/ViewLead.vue';
import ViewSubscription from '../pages/ViewSubscription.vue';
import ViewDeliveryPerson from '../pages/ViewDeliveryPerson.vue';
import TicketsIndex from "../pages/tickets/Index.vue";
import TicketsCreate from "../pages/tickets/Create.vue";
import TicketsShow from "../pages/tickets/Show.vue"
import CreateEntityLog from "../pages/CreateEntityLog.vue";
import BottleExchangeCreate from "../pages/bottle-exchange/Create.vue";
import BottleExchangeIndex from "../pages/bottle-exchange/Index.vue";
import ShopLogsIndex from "../pages/shop-log/index.vue";
import ShopLogsCreate from "../pages/shop-log/create.vue";
import BottleExchangeEdit from "../pages/bottle-exchange/Edit.vue";

export default createRouter({
  history: createWebHashHistory(),

  routes: [
    { path: '/', name: 'Login', component: Login },
    { path: '/dash', name: 'Dashboard', component: Dashboard },
    { path: '/customers', name: 'Customers', component: Customers },
    { path: '/customers/sort', name: 'CustomersSort', component: CustomersSort },
    { path: '/customers/potential-dropout', name: 'CustomersPotentialDropout', component: CustomersPotentialDropout },
    { path: '/customers/low-balance', name: 'CustomersLowBalance', component: CustomersLowBalance },
    { path: '/customers/new', name: 'CreateCustomer', component: CreateCustomer },
    { path: '/customers/:id', name: 'ViewCustomer', component: ViewCustomer },
    { path: '/customers/:id/map', name: 'CustomerMapLocation', component: CustomerMapLocation },
    { path: '/transactions', name: 'Transactions', component: Transactions },
    { path: '/groups', name: 'Groups', component: Groups },
    { path: '/vacations', name: 'Vacations', component: Vacations },
    { path: '/leads', name: 'Leads', component: Leads },
    { path: '/leads/new', name: 'CreateLead', component: CreateLead },
    { path: '/leads/:id', name: 'ViewLead', component: ViewLead },
    { path: '/delivery-persons', name: 'DeliveryPersons', component: DeliveryPersons },
    { path: '/delivery-persons/:id/salary', name: 'DeliveryPersonsTransaction', component: DeliveryPersonsTransaction },
    { path: '/delivery-persons/new', name: 'CreateDeliveryPerson', component: CreateDeliveryPerson },
    { path: '/delivery-persons/:id', name: 'ViewDeliveryPerson', component: ViewDeliveryPerson },
    { path: '/delivery-persons/:id/entity-logs', name: 'CreateEntityLog', component: CreateEntityLog },
    { path: '/delivery-intents', name: 'DeliveryIntents', component: DeliveryIntents },
    { path: '/subscriptions', name: 'Subscriptions', component: Subscriptions },
    { path: '/subscriptions/new', name: 'CreateSubscription', component: CreateSubscription },
    { path: '/subscriptions/:id', name: 'ViewSubscription', component: ViewSubscription },
    { path: '/vacations/new', name: 'CreateVacation', component: CreateVacation },
    { path: '/notifications', name: 'Notifications', component: Notifications },
    { path: '/notifications/new', name: 'CreateNotification', component: CreateNotification },
    { path: '/groups/new', name: 'CreateGroup', component: CreateGroup },
    { path: '/transactions/new', name: 'CreateTransaction', component: CreateTransaction },
    { path: '/deliveries/:date', name: 'Deliveries', component: Deliveries },
    { path: '/orders', name: 'Orders', component: Orders },
    { path: '/orders/past', name: 'PastOrders', component: PastOrders },
    { path: '/feedback', name: 'CreateFeedback', component: CreateFeedback },
    { path: '/profile', name: 'Profile', component: Profile },
    { path: '/profile/map', name: 'ProfileMap', component: ProfileMap },
    { path: '/switch-profile', name: 'SwitchProfile', component: SwitchProfile },

    { path: '/reports', name: 'Reports', component: Reports },
    { path: '/reports/lowbalance', name: 'ReportLowBalance', component: ReportLowBalance },
    { path: '/reports/transactions', name: 'ReportTransactions', component: ReportTransactions },
    { path: '/reports/commission', name: 'ReportCommission', component: ReportCommission },
    { path: '/reports/customer-summary', name: 'ReportCustomerSummary', component: ReportCustomerSummary },
    { path: '/reports/emptybottle-summary', name: 'ReportEmptyBottleSummary', component: ReportEmptyBottleSummary },
    { path: '/reports/crate-summary', name: 'ReportCrateSummary', component: ReportCrateSummary },
    { path: '/reports/dealertnx-summary', name: 'ReportDealerTnxSummary', component: ReportDealerTnxSummary },
    { path: '/reports/sample-slots', name: 'ReportDealerSampleSlot', component: ReportDealerSampleSlot },
    { path: '/reports/dp-attendance-summary', name: 'ReportDeliveryPersonsAttendanceSummary', component: ReportDeliveryPersonsAttendanceSummary },
    { path: '/reports/dp-transaction-summary', name: 'ReportDeliveryPersonsTransactionSummary', component: ReportDeliveryPersonsTransactionSummary },
    { path: '/reports/empty-bottle-count-summary/:date', name: 'ReportPendingBottleReturnSummary', component: ReportPendingBottleReturnSummary },
    { path: '/reports/empty-bottle-count-all-summary', name: 'ReportPendingBottleReturnAllSummary', component: ReportPendingBottleReturnAllSummary },

    { path: '/tickets', name: 'TicketsIndex', component: TicketsIndex },
    { path: '/tickets/create', name: 'TicketsCreate', component: TicketsCreate },
    { path: '/tickets/:id', name: 'TicketsShow', component: TicketsShow },

    { path: '/bottle-exchange', name: 'BottleExchangeIndex', component: BottleExchangeIndex },
    { path: '/bottle-exchange/create/:id', name: 'BottleExchangeCreate', component: BottleExchangeCreate },
    { path: '/bottle-exchange/edit', name: 'BottleExchangeEdit', component: BottleExchangeEdit },

    { path: '/shop-logs', name: 'ShopLogsIndex', component: ShopLogsIndex},
    { path: '/shop-logs/create', name: 'ShopLogsCreate', component: ShopLogsCreate},

    { path: '/:path(.*)*', name: 'NotFound', component: NotFound },
  ],

  scrollBehavior() { return { x: 0, y: 0 }; },
});
